import { useField } from 'formik';
import PropTypes from 'prop-types';
import React from 'react';

import { Select } from '../../lib/Form';
import useSmallScreen from '../../lib/hooks/useSmallScreen';
import TableTransposed from '../../Molecules/Tables/TableTransposed';

import ChannelsTable from './ChannelsTable';
import { poweredDownPortsProps, switchDataProps } from './propTypes';

const Channels = ({
  switchData,
  portStatus,
  children,
  poweredDownPorts,
  noInternetPorts,
  editing,
}) => {
  const isMediumScreen = useSmallScreen('md');
  const arr = useField({
    name: 'selected_layout',
  });
  const { value } = arr[1];
  const { setValue } = arr[2];
  const layout = switchData.find((data) => data.id === value);

  const setConfigValue = (e) => {
    setValue(+e.target.value);
  };

  return (
    <>
      <TableTransposed
        className="table table-bordered border-bottom-0 mb-0"
        isCompact={isMediumScreen}
      >
        <tr>
          <th
            className={
              isMediumScreen
                ? 'text-uppercase text-gray-500 text-sm'
                : 'align-top text-uppercase small font-weight-bold'
            }
            style={{ width: 140 }}
          >
            Configuration
          </th>
          <td>
            {editing ? (
              <div className="pb-4">
                <Select
                  name="selected_layout"
                  groupClassName="mb-0"
                  onChange={setConfigValue}
                >
                  {switchData.map(({ id, name }) => (
                    <option key={id} value={id}>
                      {name}
                    </option>
                  ))}
                </Select>
              </div>
            ) : (
              <div>
                <div className="font-weight-bold py-1 py-md-0 pb-md-4">
                  {layout.name}
                </div>
              </div>
            )}
            <div>{layout.description}</div>
          </td>
        </tr>
      </TableTransposed>
      <div className="bg-gray-300 py-1 pl-3 font-weight-bold">Port Status</div>
      <ChannelsTable
        editing={editing}
        switchData={layout}
        portStatus={portStatus}
        poweredDownPorts={poweredDownPorts}
        noInternetPorts={noInternetPorts}
      >
        {children}
      </ChannelsTable>
    </>
  );
};

Channels.propTypes = {
  children: PropTypes.node.isRequired,
  editing: PropTypes.bool.isRequired,
  poweredDownPorts: poweredDownPortsProps,
  noInternetPorts: poweredDownPortsProps,
  switchData: switchDataProps,
  portStatus: PropTypes.shape({}),
};

export default Channels;
